<template>
  <div class="news-details">
    <div class="news-details-content">
        <h1 class="news-title">{{ details.title }}</h1>
        <p class="news-date">{{ details.created_at }}</p>
        <div class="news-content" v-html="details.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      details: {
        title: '',
        created_at: '',
        content: ''
      },
      queryId: this.$route.query.id || '',
      loading: true,
      total: 0,
      queryParams: {
        page: 0,
        count: 10,
        scope: 'sketch'
      },
    };
  },
  created() {
    this.getNewsList();
    console.log('$route.query.id', this.$route.query.id)
  },
  methods: {
    getNewsList() {
      this.loading = true
      this.$axios.get('https://s.rendercool.com/api/v1/common/news/list', { params: this.queryParams })
        .then(response => {
          console.log(response.data)
          if (response.status == 200) {
            const newsList = response.data.collection;
            this.total = response.data.total_nums;
            newsList.filter(item => {
              if (item.id == this.queryId) {
                this.details.title = item.title;
                this.details.created_at = item.created_at;
                this.details.content = item.html;
              }
            });
          } else {
            this.$message.error('没有更多数据')
          }
        })
        .catch(error => {
          console.error(error)
          this.$message.error('获取新闻列表失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.news-details {
  /* background-color: #161b1f; */
  font-size: 16px;
  line-height: 32px;
}
.news-details-content {
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;
}
.news-title {
  font-size: 30px;
  line-height: 1.4;
  margin-bottom: 14px;
  font-weight: 700;
  color: #09ccd8;
}
.news-date {
  color: #999;
  font-size: 14px;
}
.news-content h2 {
  font-size: 24px !important;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #09ccd8;
}
</style>